import { Order } from '../services';

/**
 * Imprime a comanda em impressora térmica 80mm: abre um iframe invisível
 * com um HTML limpo (fundo branco, fontes grandes) e dispara window.print().
 * Não depende de popups (evita bloqueio de navegador).
 */
export function imprimirComanda(order: Order) {
  const itens = order.items
    .map(
      (i) => `
        <div class="item">
          <span class="qtd">${i.quantity}x</span>
          <span class="nome">${escapeHtml(i.product?.name ?? 'Produto')}${i.notes ? `<br><small>(${escapeHtml(i.notes)})</small>` : ''}</span>
          <span class="valor">${formatarBRL(Number(i.subtotal))}</span>
        </div>`,
    )
    .join('');

  const html = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Comanda ${order.id.slice(-6)}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { width: 80mm; font-family: 'Courier New', monospace; color: #000; font-size: 13px; padding: 4mm; }
  .centro { text-align: center; }
  .titulo { font-size: 18px; font-weight: bold; margin-bottom: 4px; }
  .subtitulo { font-size: 11px; margin-bottom: 8px; }
  .linha { border-top: 1px dashed #000; margin: 6px 0; }
  .topo { display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 4px; }
  .mesa { font-size: 22px; font-weight: bold; text-align: center; margin: 8px 0; }
  .item { display: flex; justify-content: space-between; align-items: baseline; gap: 6px; margin: 3px 0; }
  .qtd { font-weight: bold; white-space: nowrap; }
  .nome { flex: 1; }
  .valor { white-space: nowrap; }
  .total { display: flex; justify-content: space-between; font-size: 15px; font-weight: bold; border-top: 2px solid #000; margin-top: 6px; padding-top: 6px; }
  .obs { margin-top: 6px; font-size: 11px; border-top: 1px dashed #000; padding-top: 4px; }
  .rodape { text-align: center; margin-top: 8px; font-size: 11px; }
  @media print { body { width: 80mm; } }
</style>
</head>
<body>
  <div class="centro">
    <div class="titulo">PrimeClick</div>
    <div class="subtitulo">Comanda de cozinha</div>
  </div>
  <div class="topo">
    <span>${escapeHtml(order.customer_name)}</span>
    <span>${new Date(order.created_at).toLocaleString('pt-BR')}</span>
  </div>
  ${order.table_number ? `<div class="mesa">MESA ${order.table_number}</div>` : ''}
  <div class="linha"></div>
  ${itens}
  <div class="linha"></div>
  <div class="total">
    <span>TOTAL</span>
    <span>${formatarBRL(Number(order.total))}</span>
  </div>
  ${order.notes ? `<div class="obs"><strong>Obs:</strong> ${escapeHtml(order.notes)}</div>` : ''}
  <div class="rodape">Pedido #${order.id.slice(-6).toUpperCase()}</div>
</body>
</html>`;

  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow?.document;
  if (!doc) {
    document.body.removeChild(iframe);
    return;
  }

  doc.open();
  doc.write(html);
  doc.close();

  setTimeout(() => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    setTimeout(() => {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }, 1500);
  }, 300);
}

function escapeHtml(texto: string): string {
  return texto
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatarBRL(valor: number): string {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}